import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {DebounceFactory} from "../modules/DebounceModule";
import {StateService} from "@uirouter/angularjs";
import {QbCustomerContactDto} from "../model/QbCustomerContactDto";

class ContactListTableController implements IComponentController {
    private customerGuid: string;
    private disposeBag = new DisposeBag();
    private contacts: QbCustomerContactDto[];

    constructor(private $dataHub: DataHubService, private $scope, private $debounce: DebounceFactory,
                private $state: StateService,
                private $uibModal) {
        $dataHub.onConnected(this.reloadDebounce, this.disposeBag);
        $dataHub.bindAllContact(() => this.contacts, this.disposeBag);
    }

    reload = () => {
        if (!this.customerGuid) return;
        this.$dataHub.contactSubscribeAndQuery(this.customerGuid)
            .then(ret => {
                this.contacts = ret;
            })
            .catch(this.$dataHub.defaultErrorHandler);
    };

    reloadDebounce = this.$debounce(this.reload, 1000, false);

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.reloadDebounce();
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }


    edit(contact) {
        this.$uibModal.open({
            component: 'customerContactEdit',
            size: 'md',
            resolve: {
                contact: () => contact,
                customerGuid: () => this.customerGuid
            }
        })
    }
}

export default angular.module('component.contactListTable', [])
    .component('contactListTable', {
        template: require('./ContactListTable.html'),
        controller: ContactListTableController,
        bindings: {
            customerGuid: '<',
        }
    }).name;
